import TabCell from "../TabCell";
import {GoingUtils,AssertUtils} from "goingutils";
import {
    _initSplitBarEvent,
    _getSearchInput,
} from "../comJs";
import InitGridObj from "../../../dx/dxInitUtils/initGridObj";
import GoTabUrl from "../goTabsUrl";

class RecentUserTab extends TabCell {
    constructor(vueObj, goTabs) {
        super();
        this.tabId = GoingUtils.getUUid(10);
        this.tabIdName = "recentUser";
        this.tabLabel = "最近";
        this.active = false;
        this.initFirstData = false;
        this.hasSaveGroup = false;
        this.goTabs = goTabs;
    }

    getLeftCellContent(panelHeight) {
        return `<div class="filter-bar clearfix"> 
              <div class="search-input pull-left">  
                 ${_getSearchInput(350)}
              </div> 
            </div>
            <div class="depart-tree-div"> 
               <div id="${
            this.tabId
            }_recent_grid"  style="height: ${panelHeight};"></div>
            </div>
           `;
    }

    getRightCellContent(panelHeight) {
        let pabelHeight = panelHeight - 40 + "px";
        return `<div>
            <div class="filter-bar clearfix"> 
                 <div class="pull-left" style="height: 30px;line-height: 30px;cursor: pointer;">【保存为组】</div>
               <div class="search-input pull-right" style="margin-right: 10px;">  
                   ${_getSearchInput()}
                </div>
            </div>
             <div class="already-sel-user">
                  <div id="${
            this.tabId
            }_already_sel"  style="height: ${pabelHeight};"></div>
            </div>
         </div>`;
    }

    //初始化tabcell的容器控件
    initTabCellCtl() {
        //待选数据
        this.initWaitGrid();
        //待选择数据的表格
        this.initAlreadyGrid();
        //设置缺少值
        this.initDefEvent({topHeight: 70});
        this.initCtlEvent();
    }

    //初始化控件事件
    initCtlEvent() {
        var tabCellObj = this;
        //初始化分隔栏的事件
        _initSplitBarEvent(tabCellObj);
        this.initIconBtnEvent();
        this.searchAlReadyRecord(this);
    }

    /**
     * 获取已选择数据的表格
     */
    initWaitGrid() {
        let cellObj = this;
        let gridConfig = {
            queryUrl: GoTabUrl.getCurUserRecentUsers, // ,
            colOrderNum: true,
            colSelBox: true,
            hasPagin: false,
            afterLoadData(mygrid) {
                if (AssertUtils.isNotEmpty((cellObj).defVals)) {
                    $(((cellObj).defVals + "").split(GoingUtils.relChart)).each(
                        function (index, colVal) {
                            let rowObj = mygrid.findRowRecordByCol("name", colVal);
                            if (rowObj != null) {
                                let rowId = rowObj["id"];
                                mygrid.setCellValue(rowId, "colSelBox", true);
                                let dataAry = ["", rowObj["name"], ""];
                                cellObj.addDataToAlreadyGrid(rowId, dataAry);
                            }
                        }
                    );
                }
            },
            headerBar: true,
            moreSel: true,
            onCheckbox(rowId, cellInd, state) {
                let dataJson = cellObj.waitSelGrid.getRowRecord(rowId);
                if (state) {
                    let dataAry = ["", dataJson["name"], ""];
                    cellObj.addDataToAlreadyGrid(rowId, dataAry);
                } else {
                    cellObj.delRecordFromAlreadyGrid(rowId);
                }
            },
            onClick(rowId) {
                let dataJson = cellObj.waitSelGrid.getRowRecord(rowId);
                //表示选中
                if (dataJson.selBox === 1 || dataJson.selBox === "1") {
                    let dataAry = ["", dataJson["name"], ""];
                    cellObj.addDataToAlreadyGrid(rowId, dataAry);
                } else {
                    cellObj.delRecordFromAlreadyGrid(rowId);
                }
            },
            fieldAry: [
                {
                    id: "realName",
                    required: true,
                    type: "ro",
                    sorting: "str",
                    align: "left",
                    label: "用户名称",
                    width: "*"
                },
                {
                    id: "organizationName",
                    required: true,
                    type: "ro",
                    sorting: "str",
                    align: "left",
                    label: "所属部门",
                    width: "*"
                }
            ]
        };
        //已选数据
        let selGrid = InitGridObj(this.tabId + "_recent_grid", gridConfig, null);
        cellObj.waitSelGrid = selGrid;
    }

    loadSysDefData() {
        var curTabObj = this;
        //如果还未加载过数据 就重新加载 如果加载过了 就不重复加载
        if (!this.initFirstData) {
            this.waitSelGrid.flushGridByUrl({
                url: GoTabUrl.getCurUserRecentUsers,
                backFun: function () {
                    curTabObj.initFirstData = true;
                }
            });
        }
    }

    allCheckBoxClick() {
    }

    changeAccountEvent() {
    }

    destructionTab() {
    }

    removeSelectedRecord(){
    }
}

function initRecentUserTab(goTabs, vueObj) {
    let recentUserTab = new RecentUserTab(vueObj, goTabs);
    goTabs.addTabToFactory("recentUser", recentUserTab);
}

export default initRecentUserTab;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/recentUserTab.js